import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateSortAdminConversationCategory } from '@entities/AdminConversationCategory/api/handlers/updeteSortAdminConversationCategory';

export function useUpdateSortAdminConversationCategory() {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: updateSortAdminConversationCategory,
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['adminConversationCategories'] });
        },
    });
}
